var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
var componentLB = 'loyalty-benefits';
/*  ------ Utils ------ */
var useBulkListeners = function (callback, eventNames) {
    useEffect(function () {
        eventNames.forEach(function (eventStr) {
            window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on("".concat(componentLB, ".").concat(eventStr), callback);
        });
        return function () {
            eventNames.forEach(function (eventStr) {
                window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off("".concat(componentLB, ".").concat(eventStr));
            });
        };
    }, []);
};
var genericTrigger = function (eventOutput, eventName) {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger("".concat(componentLB, ".").concat(eventName), __assign({}, eventOutput));
};
/*  ----- Listeners ----- */
var useInfoOffersActivateListeners = function (callBack) {
    var eventNames = ['reward-barcode-drawer__activate-offer'];
    useBulkListeners(callBack, eventNames);
};
var useInfoPerksActivateListeners = function (callBack) {
    var eventNames = ['perk-selection-drawer__activate-perk'];
    useBulkListeners(callBack, eventNames);
};
var useInfoRewardsActivateListeners = function (callBack) {
    var eventNames = [
        'reward-barcode-drawer__activate-offer',
        'perk-selection-drawer__activate-perk',
    ];
    useBulkListeners(callBack, eventNames);
};
/**
 * Feature Switch Listener: Top Savings positioning
 * T&T team controls placement through Rehub IS_TOP_SAVINGS flag
 * Accepted values from Rehub: 'top', 'middle', 'off' (default: 'off')
 *
 * - 'top': Renders TopSavings at top of RewardTiers
 * - 'middle': Renders TopSavings after Paint Rewards (VIP/Elite only)
 * - 'off': Component not rendered
 */
var useTopSavingsPositionListeners = function (callBack) {
    var eventNames = ['layout-manager__top-savings-position'];
    useBulkListeners(callBack, eventNames);
};
/*  ------ Triggers ----- */
var triggerRewardBarcodeDrawer = function (eventOutput) {
    return genericTrigger(eventOutput, 'reward-barcode-drawer');
};
var triggerPerkSelectionDrawer = function (eventOutput) {
    return genericTrigger(eventOutput, 'perk-selection-drawer');
};
/**
 * Feature Switch Triggers for T&T team
 * These provide the expected LAYOUT_MANAGER.ADD_FS format
 * T&T will use these to control TopSavings positioning during A/B testing
 */
var triggerLayoutManagerFS = function (featureSwitchProps) {
    // IS_TOP_SAVINGS
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('LAYOUT_MANAGER.ADD_FS', __assign({}, featureSwitchProps));
};
// Convenience triggers for T&T team
var triggerTopSavingsTop = function () {
    return triggerLayoutManagerFS({ 'fs-prop:IS_TOP_SAVINGS': 'top' });
};
var triggerTopSavingsMiddle = function () {
    return triggerLayoutManagerFS({ 'fs-prop:IS_TOP_SAVINGS': 'middle' });
};
var triggerTopSavingsLast = function () {
    return triggerLayoutManagerFS({ 'fs-prop:IS_TOP_SAVINGS': 'last' });
};
var triggerTopSavingsOff = function () {
    return triggerLayoutManagerFS({ 'fs-prop:IS_TOP_SAVINGS': 'off' });
};
/*  ------ Exports ----- */
export var DrawerEventListeners = {
    useInfoOffersActivateListeners: useInfoOffersActivateListeners,
    useInfoPerksActivateListeners: useInfoPerksActivateListeners,
    useInfoRewardsActivateListeners: useInfoRewardsActivateListeners,
    useTopSavingsPositionListeners: useTopSavingsPositionListeners,
};
export var DrawerEventTriggers = {
    triggerRewardBarcodeDrawer: triggerRewardBarcodeDrawer,
    triggerPerkSelectionDrawer: triggerPerkSelectionDrawer,
    triggerTopSavingsTop: triggerTopSavingsTop,
    triggerTopSavingsMiddle: triggerTopSavingsMiddle,
    triggerTopSavingsLast: triggerTopSavingsLast,
    triggerTopSavingsOff: triggerTopSavingsOff,
};
